'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var CustomPropTypes = require('../CustomPropTypes.js');
var constants = require('../constants.js');
var styledBreakpoint = require('./styledBreakpoint.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var gridColumn = (function () {
  let {
    columns = constants.columns,
    styledBreakpointOptions = {
      suffix: '-columns'
    },
    defaultProps = {}
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return component => {
    const {
      component: Component,
      propNames
    } = styledBreakpoint["default"](styledBreakpointOptions)(component);
    const GridColumn = props => {
      const newProps = propNames.reduce((allNewProps, propName) => {
        let value = allNewProps[propName];
        if (!value) return allNewProps;
        if (value === 'auto') {
          value = `
            float: left;
            width: auto;
            max-width: 100%;
          `;
        } else {
          const percentage = value / columns * 100;
          value = `
            float: left;
            width: ${percentage}%;
            max-width: ${percentage}%;
          `;
        }
        return {
          ...allNewProps,
          [propName]: value
        };
      }, props);
      return /*#__PURE__*/React__default["default"].createElement(Component, newProps);
    };
    GridColumn.defaultProps = defaultProps;
    GridColumn.propTypes = propNames.reduce((allPropTypes, propName) => ({
      ...allPropTypes,
      [propName]: PropTypes__default["default"].oneOfType([PropTypes__default["default"].oneOf(['auto']), CustomPropTypes["default"].integerRange(1, columns)])
    }), {});
    return GridColumn;
  };
});

exports["default"] = gridColumn;
